import React from "react";
import { Link } from "react-router-dom";
import bg from "../../assets/videos/Vertical1.mp4";
import "./styles.css";

export const Memories = () => {
  return (
    <div className="container  mt-5 " style={{ marginBottom: "70px" }}>
      <div className="second oo innerContainer ">
        <div
          className="vidContainer"
          data-aos="fade-up"
          style={{
            pointerEvents: "none",
            position: "relative",
          }}
        >
          <video
            className="video21"
            src={bg}
            autoPlay
            loop
            muted={true}
            playsInline
            controlsList="nodownload nofullscreen noremoteplayback"
            disablePictureInPicture
            style={{
              pointerEvents: "none", // Extra protection against interaction
              userSelect: "none", // Prevent text selection
              WebkitTouchCallout: "none",
            }}
          ></video>
        </div>
        <div
          className="inners"
          style={{
            backgroundColor: "#CEC4C0",
            padding: "15px",
            borderRadius: "20px",
          }}
          data-aos="fade-up"
        >
          <div className="momentContainer">
            <h3 className="text">MODERN CLASSICS MEETS</h3>
            <h2 className="title">TIMELESS CHARM</h2>
            <p className="description2">
              Dive into unspoken love, whispered promises, and shared laughter
              painting your vibrant love story. We embody modern classics,
              blending elegance with timeless charm, capturing endearing moments
              in a narrative of depth, creating lasting modern heartfelt
              memories.
            </p>
            <Link to="/contact">
              <button
                className="watchFilmsButton"
                style={{ backgroundColor: "#CEC4C0" }}
              >
                Get in Touch{" "}
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
